// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div[data-v-4f2c5e4c]:not(.lightbox-media){width:100%;height:100%}div[data-lightbox-status=true][data-v-4f2c5e4c]{cursor:zoom-in}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
